import {Injectable} from "@angular/core";
import {CredentialsCache} from "../../../common/auth";
import {DeployedEnv} from "../../env";
import {HttpWrapper} from "./http.wrapper";
import {HttpDataPovider} from "./user.ctx.token";
import {HttpClient} from "@angular/common/http";

@Injectable({ providedIn: 'root' })
  export class ConfProxy extends HttpWrapper {
	constructor(http:HttpClient, tokenProvider:CredentialsCache, apiDetails:DeployedEnv, httpData:HttpDataPovider ) {
		super(http, tokenProvider, apiDetails.confUrl(),httpData);
	}
}
